module.exports = __webpack_public_path__ + "img/ewm.47b338d1.jpg";